<!-- 针对于input type='number' 与fastClick 等做的处理 的时候进行的处理-->
<template>
  <x-input title='客户手机' placeholder='非必填，11位数字' type="tel" :max="maxLength" v-model="currentValue" @on-change="changeValue"></x-input>
</template>

<script>
import {
  XInput
} from '@lx-frontend/cvux'
export default {
  components: { XInput },
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    maxLength: {
      type: Number,
      default: 11
    },
    placeholder: {
      type: String,
      default: '非必填，11位数字'
    },
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      currentValue: ''
    }
  },
  created() {
    this.setValue(this.value)
  },
  watch: {
    currentValue(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.setValue(val)
    }
  },
  methods: {
    setValue(value) {
      this.currentValue = value ? `${value}` : ''
    },
    changeValue(value) {
      this.$nextTick(() => {
        this.currentValue = value.replace(/\D/g, '')
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
